import { bigint, index, integer, jsonb, pgTable, smallint, text, timestamp, unique, uuid, } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export var WebsiteCrawlStatus;
(function (WebsiteCrawlStatus) {
    WebsiteCrawlStatus["Pending"] = "pending";
    WebsiteCrawlStatus["Running"] = "running";
    WebsiteCrawlStatus["Succeeded"] = "succeeded";
    WebsiteCrawlStatus["Failed"] = "failed";
    WebsiteCrawlStatus["Blocked"] = "blocked";
})(WebsiteCrawlStatus || (WebsiteCrawlStatus = {}));
export const organisationWebsiteCrawls = pgTable("organisation_website_crawls", {
    id: uuid("id").primaryKey().defaultRandom(),
    organisationId: uuid("organisation_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    status: text("status")
        .notNull()
        .$type()
        .default(WebsiteCrawlStatus.Pending),
    pageBudget: smallint("page_budget").notNull().default(25),
    pagesFetched: smallint("pages_fetched").notNull().default(0),
    pagesIndexed: smallint("pages_indexed").notNull().default(0),
    bytesFetched: bigint("bytes_fetched", { mode: "number" }).notNull().default(0),
    startedAt: timestamp("started_at", { withTimezone: true }),
    completedAt: timestamp("completed_at", { withTimezone: true }),
    lastRunAt: timestamp("last_run_at", { withTimezone: true }),
    lastSuccessAt: timestamp("last_success_at", { withTimezone: true }),
    failureReason: text("failure_reason"),
    metadata: jsonb("metadata").notNull().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    lastUpdatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    orgStatusIdx: index("idx_org_website_crawls_org_status").on(table.organisationId, table.status),
    orgCreatedIdx: index("idx_org_website_crawls_created").on(table.organisationId, table.createdAt),
}));
export var WebsitePageStatus;
(function (WebsitePageStatus) {
    WebsitePageStatus["Pending"] = "pending";
    WebsitePageStatus["Fetched"] = "fetched";
    WebsitePageStatus["Indexed"] = "indexed";
    WebsitePageStatus["Blocked"] = "blocked";
    WebsitePageStatus["Failed"] = "failed";
})(WebsitePageStatus || (WebsitePageStatus = {}));
export const organisationWebsitePages = pgTable("organisation_website_pages", {
    id: uuid("id").primaryKey().defaultRandom(),
    organisationId: uuid("organisation_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    crawlId: uuid("crawl_id")
        .notNull()
        .references(() => organisationWebsiteCrawls.id, { onDelete: "cascade" }),
    url: text("url").notNull(),
    normalizedUrl: text("normalized_url"),
    parentUrl: text("parent_url"),
    contentRef: text("content_ref"),
    contentHash: text("content_hash"),
    tags: jsonb("tags").notNull().default([]),
    summary: text("summary"),
    status: text("status").notNull().$type().default(WebsitePageStatus.Pending),
    httpStatus: integer("http_status"),
    httpHeaders: jsonb("http_headers"),
    blockedReason: text("blocked_reason"),
    fetchedAt: timestamp("fetched_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    lastUpdatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    orgUrlIdx: index("idx_org_website_pages_org_url").on(table.organisationId, table.normalizedUrl),
    crawlIdx: index("idx_org_website_pages_crawl").on(table.crawlId),
    uniqueOrgUrlHash: unique("unique_org_website_page_hash").on(table.organisationId, table.normalizedUrl, table.contentHash),
}));
export const organisationProducts = pgTable("organisation_products", {
    id: uuid("id").primaryKey().defaultRandom(),
    organisationId: uuid("organisation_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    slug: text("slug").notNull(),
    name: text("name").notNull(),
    summary: text("summary"),
    aliases: jsonb("aliases").notNull().default([]),
    pricing: jsonb("pricing").notNull().default([]),
    capabilities: jsonb("capabilities").notNull().default([]),
    targetSegments: jsonb("target_segments").notNull().default([]),
    evidence: jsonb("evidence").notNull().default([]),
    sources: jsonb("sources").notNull().default([]),
    lastUpdatedAt: timestamp("last_updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    uniqueOrgProductSlug: unique("unique_org_product_slug").on(table.organisationId, table.slug),
    orgNameIdx: index("idx_org_products_name").on(table.organisationId, table.name),
}));
export const organisationWebsiteCrawlQuestions = pgTable("organisation_website_crawl_questions", {
    id: uuid("id").primaryKey().defaultRandom(),
    organisationId: uuid("organisation_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    crawlId: uuid("crawl_id")
        .notNull()
        .references(() => organisationWebsiteCrawls.id, { onDelete: "cascade" }),
    questionId: text("question_id").notNull(),
    confidence: smallint("confidence").notNull().default(0),
    notes: jsonb("notes").notNull().default([]),
    evidence: jsonb("evidence").notNull().default([]),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    lastUpdatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    orgCrawlQuestionIdx: unique("unique_org_crawl_question").on(table.organisationId, table.crawlId, table.questionId),
}));
